import React, { Component } from "react";
import classes from "./Admin.module.css";
import { NavLink } from "react-router-dom";

import calendar from "../../../pics/calendar.svg";
import scissors from "../../../pics/scissors.svg";
import master from "../../../pics/master.svg";
import logout from "../../../pics/logout.svg";

class Admin extends Component {
  render() {
    return (
      <div className={classes.Admin}>
        <div className={classes.Admin_nav}>
          <nav>
            <ul>
              <li>
                <NavLink to="/admin/look" activeClassName={classes.active}>
                  <img
                    style={{ cursor: "pointer" }}
                    src={calendar}
                    alt="calendar"
                  />
                </NavLink>
              </li>

              <li>
                <NavLink to="/admin/offer" activeClassName={classes.active}>
                  <img
                    style={{ cursor: "pointer" }}
                    src={scissors}
                    alt="edit"
                  />
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/master" activeClassName={classes.active}>
                  <img
                    style={{ cursor: "pointer" }}
                    src={master}
                    alt="master"
                  />
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/logout" activeClassName={classes.active}>
                  <img
                    style={{ cursor: "pointer" }}
                    src={logout}
                    alt="logout"
                  />
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default Admin;
